export default {
  methods: {
    isEditable(event) {
      if (this.isSafariCheck) {
        if (event.target.isContentEditable) {
          return;
        }
        event.preventDefault();
      }
    },
  },
};
